import { i18n } from 'i18n';
import * as invitationsPageConstants from './InvitationsPage/constants';
import * as usersPageConstants from './UsersPage/constants';

export const BASE_PATH = '/admin/users';
export const ROUTE_PATH = `${BASE_PATH}/*`;
export const TITLE = i18n._('Users');

export const INVITATION_ROUTE_PATH = BASE_PATH + invitationsPageConstants.ROUTE_PATH;
export const INVITATION_TITLE = invitationsPageConstants.TITLE;

export const USER_ACCOUNTS_ROUTE_PATH = BASE_PATH + usersPageConstants.ROUTE_PATH;
export const USER_ACCOUNTS_TITLE = usersPageConstants.TITLE;
